import { api } from '../../lib/api'
import ChatPanel from './ChatPanel'

export default function JobChat({ jobId, onJobUpdated }: { jobId: string; onJobUpdated?: () => void }) {
  return (
    <ChatPanel
      onAsk={async (text) => {
        const res = await api.jobs.chat(jobId, text)
        return res.data.reply
      }}
      onAddInfo={async (text) => {
        await api.jobs.update(jobId, text)
        onJobUpdated?.()
      }}
      onNote={async (text) => {
        await api.jobs.updateFrontmatter(jobId, { notes: text })
      }}
      placeholders={{
        ask: 'Ask anything about this job...',
        addInfo: 'Add new information to merge into the job profile...',
        note: 'Leave a private note (visible only in frontmatter)...',
      }}
      emptyHints={{
        ask: 'Ask anything about this job.',
        addInfo: 'Paste or type new information to merge into the job profile.',
        note: 'Leave a private note. It will be stored in the job frontmatter.',
      }}
    />
  )
}
